import React, { useCallback } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { AppRoutes } from '@/routes';
import { useTranslate } from '@/translations';
import { faClipboardCheck, PageContainer, Title } from '@/ui/components';
import { ResponseDetailCard } from './components/ResponseDetailCard';

export const ResponseDetailPage = () => {
  const { t } = useTranslate();
  const { accent } = useTheme();
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const toList = useCallback(
    () => navigate(AppRoutes.questionnaireResponses),
    [navigate],
  );

  const responseId = Number(id);
  if (!Number.isInteger(responseId)) {
    return <Navigate to={AppRoutes.questionnaireResponses} replace />;
  }

  return (
    <PageContainer>
      <Title
        title={t('questionnaireResponses')}
        icon={faClipboardCheck}
        color={accent}
      />
      <ResponseDetailCard responseId={responseId} onBack={toList} />
    </PageContainer>
  );
};
